// Services.js
import React from 'react';
import { Link } from 'react-router-dom';
import './Services.css'; // Assurez-vous de créer ce fichier CSS

const services = [
  { id: 1,description: 'CHANTIER', imageUrl: '/service1.jpeg' },
  { id: 2,description: 'HOPITAUX', imageUrl: '/hopitale.jpg' },
  { id: 3,description: 'JARDINAGE', imageUrl: '/jardinage.jpg' },
  { id: 4,description: 'Nettoyage INDUSTRIEL', imageUrl: '/netoyage industrielle.jpg' },
  { id: 5,description: 'VITRES', imageUrl: '/vitres.jpeg' },
  { id: 6,description: 'PANNEAUX', imageUrl: '/nettoyage panneu .jpg' },
  { id: 7,description: 'CRISTALISATION', imageUrl: '/netoyage marbre.jpg' },
  { id: 8,description: 'ECOLES', imageUrl: '/ecole.jpg' },
  { id: 9,description: 'Industrie Agro-Alimentaire', imageUrl: '/netoyage industrie agroaliment.jpg' },
  { id: 10,description: 'COPROPRIETE', imageUrl: '/corporité.jpg' },
  { id: 11,description: 'Nettoyage événementiel', imageUrl: '/party.webp' },
  { id: 12,description: 'Traitement des nuisibles', imageUrl: '/nuisible.jpg' },
  { id: 13,description: 'CANAPE / MOQUETTE', imageUrl: '/canape.jpg' },
  { id: 14,description: 'BUREAUX', imageUrl: '/burreau.jpg' },
  { id: 15,description: 'HOTELS / RESTAUX ', imageUrl: '/restau.jpg' },
  { id: 16,description: 'COMMERCES / LOCAUX', imageUrl: '/commerce.jpg' },
];

const Services = () => {
  return (
    <div className='serv'>
    <div class="bann">
 <div class="imag-containr">
   <img src="/aboutt.jpg" alt="Instruments de ménage" class="bann-image" loading="lazy"/>
 </div>
 <div class="bann-content">
   <h1>NOS SERVICES
   <h5 class="banner-subt">Service nettoyage <span className='greater'>&gt;</span> Services</h5></h1>
 </div>
</div>
<div className='abtus'>
<h1 className='Qst'>  <img src="/freakels.png" className='Qs' loading="lazy"/>Que faisons-nous ?</h1>
<div class="ones">
<h5>Explorez notre gamme de services sur mesure pour répondre à vos besoins.</h5>

</div>
</div>
    <div className="servic-container">
      {services.map(service => (
        <Link to={`/service/${service.id}`} key={service.id} className="servic-card">
          <img src={service.imageUrl} alt={service.title} className="servic-image"loading="lazy" />
          <p className="service-description">{service.description}</p>
        </Link>
      ))}
    </div>
<h1 className='Dst'>  <img src="/freakels.png" className='Qs'loading="lazy" />Pourquoi<span className='Hm'> Nous Choisir ?</span> </h1>
<h4 className='termine '> Expert en nettoyage à Agadir, Casablanca et Marrakech.</h4>
    <div className="cords-container">
    <div className="cord">
        <img src="/janitor.png" alt="Service 1" className="cord-image" loading="lazy"/>
        <div className="cord-content">
        <h4>Son expertise</h4>
            <p>Nous avons une connaissance approfondie des différents types de locaux 
           <br /> Notre équipe est composée d'agents d'entretien expérimentés et formés aux dernières techniques de nettoyage.
</p>
        </div>
    </div>
    <div className="cord">
        <img src="/qualitative-research.png" alt="Service 2" className="cord-image"loading="lazy" />
        <div className="cord-content">
         <h4> Qualité d'engagement</h4>
            <p>Nous nous engageons à fournir un service de qualité irréprochable, en utilisant des produits professionnels et en respectant les normes d'hygiène et de sécurité les plus strictes.
            </p>
        </div>
    </div>
    <div className="cord">
        <img src="/7-days.png" alt="Service 3" className="cord-image"loading="lazy" />
        <div className="cord-content">
          <h4>Sa réactivité et flexibilité</h4>
            <p>Nous sommes disponibles 7j/7 et intervenons dans les meilleurs délais pour répondre à vos besoins.
           <br /> Nous nous adaptons à vos contraintes horaires et à vos exigences spécifiques.</p>
        </div>
    </div>
    <div className="cord">
        <img src="/availability.png" alt="Service 4" className="cord-image"loading="lazy" />
        <div className="cord-content">
          <h4>Ses tarifs compétitifs </h4>
            <p>Nous proposons des tarifs compétitifs et adaptés à votre budget.
           <br /> Nous sommes transparents dans nos devis et ne facturons aucun frais caché.</p>

        </div>
    </div>
</div>

    </div>
  );
};

export default Services;
